import axios from "axios";
import { Base_URL } from "../url";

export const fetchExternalSystems = async () => {
  try {
    const response = await axios.get(`${Base_URL}/ExternalSystem/GetAllExternalSystems`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching external systems!";
  }
};

export const downloadExternalSystemsExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/ExternalSystem/DownloadExternalSystemsExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading external systems data!";
  }
};